import styled from 'styled-components';

export const AutoDownloadContactWrapper = styled.div`
  height: 100vh;
`;
